import { theme } from 'theme'

import { SxProps } from '@mui/material'

const container: SxProps = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: 'center',
  gap: 2,
  p: 2,
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.gray.light,
    borderRadius: 2,
  },
  '&:last-of-type': {
    marginBottom: 4,
  },
}

const flexBox: SxProps = {
  display: 'flex',
  flex: 1,
  width: { xs: '100%', sm: 'auto' },
  alignItems: 'center',
  gap: 2,
}

const avatar: SxProps = {
  width: 48,
  height: 48,
  alignSelf: 'center',
}

const content: SxProps = {
  flex: 1,
}

const organizationMainInfoContainer: SxProps = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: { sm: 1, md: 3 },
  mt: 1,
}

const valueText: SxProps = {
  fontSize: 14,
  fontWeight: 400,
  display: 'inline',
}

const labelText: SxProps = {
  ...valueText,
  color: theme.palette.gray.main,
}

const viewButton: SxProps = {
  height: 'fit-content',
}

const Styles = {
  avatar,
  container,
  flexBox,
  content,
  organizationMainInfoContainer,
  labelText,
  valueText,
  viewButton,
}

export default Styles
